import { render } from "./App.vue?vue&type=template&id=5440f14c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__